import { getApiClient } from "@punchup/utils";
import { VideoUploadInsert } from "../../models/video";

export async function insertComedianVideoUpload(video: VideoUploadInsert) {
  return getApiClient().post<{ data: { id: string } }>(
    "/api/v2/manager/videos",
    { video }
  );
}
